// components/ImagePicker.jsx
import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import { useSwipeable } from "react-swipeable";
import ImageWrapper from "components/ImageWrapper";
import LeftArrowIcon from "components/icons/LeftArrowIcon";
import RightArrowIcon from "components/icons/RightArrowIcon";
import LoadSpinnerOverlay from "components/LoadSpinnerOverlay";

export default function ImagePicker({ images = [], initialIndex = 0, onChange, className, style, deviceSize, screenWidth, loadingDeepLinkDetails }) {
    const [idx, setIdx] = useState(Math.min(Math.max(initialIndex, 0), Math.max(images.length - 1, 0)));
    const indicatorsRef = useRef(null); 
    const [indicatorsHeight, setIndicatorsHeight] = useState(0);

    useLayoutEffect(() => {
        if (!indicatorsRef.current) return;
        // pick one:
        const h1 = indicatorsRef.current.offsetHeight;                   // integer, includes borders
        const h2 = indicatorsRef.current.getBoundingClientRect().height; // float, sub-pixel precise
        setIndicatorsHeight(h2);
    }, [images.length, idx, screenWidth]); // re-measure when dots or selection changes

    useEffect(() => { onChange && onChange(idx); }, [idx, onChange]);

    useEffect(() => {
        setIdx(Math.min(Math.max(initialIndex, 0), Math.max(images.length - 1, 0)));
    }, [initialIndex, images.length]);

    const next = () => setIdx((i) => (i + 1) % (images.length || 1));
    const prev = () => setIdx((i) => (i - 1 + (images.length || 1)) % (images.length || 1));

    const swipe = useSwipeable({ onSwipedLeft: next, onSwipedRight: prev, preventDefaultTouchmoveEvent: true, trackMouse: true });

    return (
        <div className={`image-picker ${className || ""}`} style={style}>
            <div {...swipe} className="picker-viewport post-page-banner" style={{ position: "relative" }}>
                {images.length > 0 ? (
                    <div>
                        {
                            loadingDeepLinkDetails ?
                                <LoadSpinnerOverlay innerStyle={{ position: "relative", top: "-47px"}} />
                                :
                        <       ></>
                        }
                        <ImageWrapper
                            src={images[idx]?.url}
                            alt="Selected image preview"
                            className="picker-image"
                            style={{ width: "145px", height: "150px", top: 0, left: 0, objectFit: "scale-down", background: "#fff", borderRadius: "10px", marginBottom: "6px" }}
                            onError={(e) => { e.target.onerror = null; e.target.src = "images/blank-banner.png"; }}
                            size="Post"
                            />
                    </div>
                ) : (
                    <img src="images/blank-banner.png" alt="" />
                )}

                {images.length > 1 && (
                    <>
                        <a
                            href="/"
                            className="left-arrow position-absolute d-flex justify-content-center align-items-center"
                            style={{ left: "20px" }}
                            onClick={(e) => {
                                e.preventDefault();
                                prev();
                            }}
                        >
                            <span>
                                <LeftArrowIcon x={16} y={16} />
                            </span>
                        </a>

                        <a
                            href="/"
                            className="right-arrow position-absolute d-flex justify-content-center align-items-center"
                            style={{ right: "20px" }}
                            onClick={(e) => {
                                e.preventDefault();
                                next()
                            }}
                        >
                            <span>
                                <RightArrowIcon x={16} y={16} />
                            </span>
                        </a>
                    </>
                )}

                {images.length > 1 && (
                    <p style={{ color: "lightgray", fontSize: "12px", marginBottom: 0 }}>{idx + 1} of {images.length}</p>
                )}
            </div>
        </div>
    );
}
